<div class="containe-fluid mapping-approval flex-column px-2">
    <div class="flex-grow-1 mt-2">
        <div class="d-flex justify-content-end p-2">
            <button (click)="approveMappings()" [disabled]="!selectedTestCases.length" class="btn  btn-accello-primary btn-approve mt-2"> Approve Mappings </button>
        </div>
        <div class="card shadow content-wrapper">
            <!-- <div class="table-title-bar header-4 p-2"> {{ clusterId }} </div> -->
            @if(isLoading) {
                <app-loading class="h-100 mx-auto" [text]="'Loading data'"></app-loading>
            } @else {
                <div class="flex-grow-1">
                    <app-zorro-table
                    tableId="mapping-approval"
                    class="w-100"
                    [columns]="tableData.columns"
                    [data]="filteredRows"
                    (handleActions)="handleTableActions($event)"
                    (onRowSelect)="handleRowSelect($event)"
                ></app-zorro-table>
            </div>
            }
        </div>
    </div>
</div>